import { Block, Flex, Icon, Modal, Typography } from '@aloft/toolkit-sui';

import { useEffect, useState } from 'react';

import SamWave from '../../../assets/sam/wave.png';
import { LoadingScreenSam } from '../../../components/LoadingScreen/LoadingScreenSam.tsx';
import {
  QUALITY_CONTROL_SLIDE_DURATION_MS,
  QUALITY_CONTROL_SUCCESS_DELAY_MS,
} from '../constants.ts';

export type ReviewModalPhase = 'hidden' | 'running' | 'success';

const SuccessCountdownBar = ({ isActive }: { isActive: boolean }) => {
  const [isCountingDown, setIsCountingDown] = useState(false);

  useEffect(() => {
    if (!isActive) {
      setIsCountingDown(false);
      return;
    }

    const animationFrame = window.requestAnimationFrame(() => setIsCountingDown(true));
    return () => window.cancelAnimationFrame(animationFrame);
  }, [isActive]);

  return (
    <Flex
      width="240px"
      height="4px"
      borderRadius="999px"
      backgroundColor="surface3"
      overflow="hidden"
    >
      <Flex
        height="100%"
        backgroundColor="textSuccess"
        __dangerDoNotUseSx={{
          transition: `width ${QUALITY_CONTROL_SUCCESS_DELAY_MS}ms linear`,
          width: isCountingDown ? '0%' : '100%',
        }}
      />
    </Flex>
  );
};

const ReviewSuccessContent = ({ isActive }: { isActive: boolean }) => (
  <Flex padding="40px" width="100%" flexDirection="column" gap="32px" alignItems="center">
    <img alt="Sam waving" src={SamWave} style={{ height: '200px' }} />
    <Flex flexDirection="column" gap="16px" alignItems="center">
      <Typography textAlign="center">
        <Icon
          icon="check-circle"
          color="textSuccess"
          size="lg"
          __styleDoNotUse={{ marginBottom: '-8px', marginRight: '5px' }}
        />
        Success! Your report is ready to certify and submit.
      </Typography>
      <SuccessCountdownBar isActive={isActive} />
    </Flex>
  </Flex>
);

export const QualityControlReviewProgressModal = ({ phase }: { phase: ReviewModalPhase }) => (
  <Modal isOpen={phase !== 'hidden'} onClose={() => {}} showCloseButton={false}>
    <Block __dangerDoNotUseSx={{ width: 'min(100%, calc(100vw - 48px))' }} overflow="hidden">
      <Flex
        __dangerDoNotUseSx={{
          display: 'flex',
          width: '200%',
          transform: phase === 'success' ? 'translateX(-50%)' : 'translateX(0)',
          transition: `transform ${QUALITY_CONTROL_SLIDE_DURATION_MS}ms ease-in-out`,
        }}
      >
        <Flex width="50%" padding="40px" flexShrink={0} boxSizing="border-box">
          <LoadingScreenSam
            overrideText="Analyzing report...this might take a few seconds.
                    Please keep this window open."
          />
        </Flex>
        <Flex width="50%" flexShrink={0} boxSizing="border-box">
          <ReviewSuccessContent isActive={phase === 'success'} />
        </Flex>
      </Flex>
    </Block>
  </Modal>
);
